<template>
  <v-app>
    <Navbar />
    <v-main>
      <router-view class="router"></router-view>
    </v-main>
  </v-app>
</template>

<script>

import Navbar from './components/NavBar.vue'
export default {
  name: 'App',
  components: { Navbar }
}
</script>




// WEBPACK FOOTER //
// src/App.vue